import { Foundation } from '../../../vendor'
import InboomaBaseView from '../InboomaBaseView'

import OrdersSortTabsTpl from '../../templates/orders/OrdersSortTabsTpl.html'

export default InboomaBaseView.extend({

    template : OrdersSortTabsTpl,
    el : '#inb-c-main-sort-nav',

    events : {
        'click li.tabs-title' : '_onClickChangeSort',
    },

    initialize () {
        this.render();
    },

    onRender () {
        // @see https://foundation.zurb.com/sites/docs/sticky.html
        Foundation.Sticky.defaults.marginTop = 0;
        const stickySortTabs = new Foundation.Sticky(this.$el);
    },

    _onClickChangeSort (ev) {

        const el = ev.currentTarget;

        const sortKey = el.getAttribute('data-inb-val'),
              direction = el.getAttribute('data-inb-direction'),
              isOppositeElement = (direction === null && el.classList.contains('is-active')),
              newDirection = (direction === 'desc' || isOppositeElement ? 'asc' : 'desc');

        if (sortKey) {

            this.collection.setSort(sortKey, newDirection);

            const activeSortTab = this.$el[0].querySelector('.is-active');

            if (activeSortTab) {
                // @todo remove/set aria-selected attribute
                activeSortTab.classList.remove('is-active');
            }
            
            el.classList.add('is-active');
            el.setAttribute('data-inb-direction', (isOppositeElement ? 'desc' : newDirection));

        }

        return false;
      
    }
});